import moment from 'moment';
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
// 时间戳转时间 time 时间戳
export const formatTime = (time, str) => {
  return moment(new Date(time)).format(str)
}